import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { LineupTable, LineupTableWrapper, Lineupwrapper, ErrorWrapper, LineupTextwrapper } from '../LineupMatchup.style';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';
import CustomPlayerCell from './CustomPlayerCell';
import CustomHeadCell from './CustomHeadCell';
import { tbodyError } from './Lineup';

const EMPTY = '-';

const tbodyDataSkel = new Array(9).fill({
    name: '',
    avg: '',
    ab: '',
    hr: '',
    rbi: ''
});

const Matchup = (props) => {
    const {
        data,
        language,
        probables = '',
        team = '',
        isDataLoaded = false
    } = props?.data || {};

    const translatedMap = {
        avg: useTranslator('labelBrief_h_avg', 'avg'),
        hr: useTranslator('labelBrief_h_hr', 'hr'),
        rbi: useTranslator('labelBrief_rbi', 'rbi'),
        ab: useTranslator('labelBrief_ab', 'ab'),
        ops: useTranslator('labelBrief_ops', 'ops'),
        lineup: useTranslator('lineups_subject_to_change', 'Lineups subject to change'),
        error: useTranslator('matchup_empty_message', 'Pending opposing pitcher information')
    };

    const customCells = useMemo(() => {
        return [
            {
                cellType: 'body',
                customCell: <CustomPlayerCell external={false} />,
                dataField: 'name'
            },
            {
                cellType: 'header',
                customCell: <CustomHeadCell />,
                dataField: 'name',
                fixedWidth: '45px'
            }
        ];
    }, [data]);

    const theadData = useMemo(() => {
        return [
            {
                content: [team, probables],
                dataField: 'name',
                alignment: 'left',
                fixedWidth: '145px'
            },
            {
                content: translatedMap.hr,
                dataField: 'hr',
                alignment: 'center'
            },
            {
                content: translatedMap.rbi,
                dataField: 'rbi',
                alignment: 'center'
            },
            {
                content: translatedMap.ab,
                dataField: 'ab',
                alignment: 'center'
            },
            {
                content: translatedMap.avg,
                dataField: 'avg',
                alignment: 'center'
            },
            {
                content: translatedMap.ops,
                dataField: 'ops',
                alignment: 'center'
            }
        ];
    }, [translatedMap]);

    const tbodyData = useMemo(() => {
        return data?.map((player) => {
            const {
                stats,
                boxscoreName,
                id,
                primaryPosition
            } = player;
            const {
                atBats,
                avg,
                homeRuns,
                rbi,
                ops
            } = stats || {};

            return {
                avg: avg || EMPTY,
                rbi: rbi || EMPTY,
                hr: homeRuns || EMPTY,
                ab: atBats || EMPTY,
                ops: ops || EMPTY,
                name: boxscoreName,
                position: primaryPosition,
                language,
                playerId: id,
                componentName: 'Match Up'
            };
        });
    }, [data]);

    const showErrorView = (typeof isDataLoaded !== 'undefined' && data?.length === 0);
    return (
        <LineupTableWrapper className={showErrorView ? 'error' : ''}>
            <LineupTable
                thead={ theadData }
                tbody={ !isDataLoaded ? tbodyDataSkel : (!showErrorView ? tbodyData : tbodyError) }
                isLoading={ !isDataLoaded }
                customCells={ isDataLoaded && !showErrorView && customCells }
                className={'matchup'}
            />

            { showErrorView && <ErrorWrapper>{ translatedMap.error }</ErrorWrapper> }
        </LineupTableWrapper>
    );
};

Matchup.propTypes = {
    data: PropTypes.object
};

export default Matchup;
